<template>
    <form @submit.prevent="submitForm">
            
        <div class="col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Hora de Inicio de Inspección</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <input type="time" class="form-control" v-model="form.hora_inicio"/>
            </div>
        </div>
        <div class="py-3 col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Hora de termino de inspección</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <input type="time" class="form-control" v-model="form.hora_termino" />
            </div>
        </div>
        <div class="py-3 col-md-12" style="text-align: left;">
            <div class="col-md-2"> 
                <label for="">Fecha de visita de inspección</label><span class="is-invalid">*</span>
            </div>
            <div class="col-md-12">
                <input type="date" class="form-control" v-model="form.fecha_visita"/>
            </div>
        </div>
        <div class="col-md-12" style="text-align: left;"> 
            <label for="">Datos relativos a la actuación durante la visita de inspección</label><span class="is-invalid">*</span>
        </div>
        <div class="col-md-12">
            <textarea name="" id="" rows="10" class="form-control" v-model="form.datos_relativos"></textarea>
        </div>
        <div class="col-md-12" style="text-align: left;"> 
            <label for="">El Representante de la instalación para la Inspección, haciendo uso del derecho que le asiste para hacer observaciones a la presente acta, manifiesta lo siguiente:</label><span class="is-invalid">*</span>
        </div>
        <div class="col-md-12">
            <textarea name="" id="" rows="10" class="form-control" v-model="form.observaciones"></textarea>
        </div>
        <br>
        <button v-if="this.datos == true" type="submit" class="btn btn-primary">Actualizar</button>
        <button v-else type="submit" class="btn btn-success" >Enviar</button>
    </form>
</template>


<script>
import axios from 'axios';
import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                form: {
                    hora_inicio: '',
                    hora_termino: '',
                    fecha_visita: '',
                    datos_relativos: '',
                    observaciones: '',
                    idcotizacion:''
                }
            }
        },
        created() {
            this.getPlanInspecciones();
        },
        methods: {
            submitForm() {
                const id = localStorage.getItem('idcotizacion');
                this.form.idcotizacion = id;
                // Verificar si la hora ya tiene segundos antes de agregar ':00'
                if (!this.form.hora_inicio.includes(':00')) {
                    this.form.hora_inicio = this.form.hora_inicio + ':00';
                }

                if (!this.form.hora_termino.includes(':00')) {
                    this.form.hora_termino = this.form.hora_termino + ':00';
                }
            axios.post(this.$rutaServer+'guardarActa', this.form)
                .then(response => {
                alert('Inspección guardada con éxito');
                // Limpiar el formulario
                /*this.form = {
                    hora_inicio: '',
                    hora_termino: '',
                    fecha_visita: '',
                    datos_relativos: '',
                    observaciones: '',
                };*/
                this.getPlanInspecciones();
                })
                .catch(error => {
                console.error(error);
                alert('Error al guardar la inspección');
                });
            },
            getPlanInspecciones() {
                const id = localStorage.getItem('idcotizacion');
                axios.post(this.$rutaServer+'consultarActa',{idcotizacion:id})
                    .then(response => {
                    if(response.data.length > 0){
                        this.datos = true;
                       
                        // Suponiendo que las inspecciones tienen los campos que coinciden con el formato de las preguntas
                    //this.preguntas = response.data.map(inspeccion => ({
                        /*servicio: inspeccion.servicio,
                        alcance: inspeccion.alcance,
                        procedimiento: inspeccion.procedimiento,
                        tecnica: inspeccion.tecnica,*/
                       /* actividad: inspeccion.actividad,
                        fecha_planeada: inspeccion.fecha_planeada,
                        fecha_cumplida: inspeccion.fecha_cumplida,
                        observaciones: inspeccion.observaciones
                    }));*/

                    
                       this.form.hora_inicio = response.data[0].hora_inicio; 
                       this.form.hora_termino = response.data[0].hora_termino;
                       this.form.datos_relativos = response.data[0].datos_relativos;
                       this.form.observaciones = response.data[0].observaciones;
                       this.form.fecha_visita = response.data[0].fecha_visita;
                    
                    }
                    
                    })
                    .catch(error => {
                    console.error("Error al obtener las inspecciones:", error);
                    });
            },
        }
    }
    </script>